<template>
  
  <!--<div class="">-->
  <!--<nav class="navbar navbar-default" id="header">-->
  <!--<nav class="navbar navbar-light bg-faded rounded navbar-toggleable-md">-->
  <nav class="navbar navbar-expand-md py-0 navbar-light bg-faded sticky-top" style="background-color: rgba(227, 242, 253, 0.95);" id="header">
    <!--<div class="d-flex justify-content-between hidden-lg-up"> ignored for v4 beta-->
    
    <router-link tag="a" class="navbar-brand" id="bname" :to="{ name: 'product', params: { language: getLang }} ">
	  <a class="navbar-brand" data-toggle="collapse" data-target=".navbar-collapse" href="#"><img src="../assets/AquaWiz_trans_minimum.png" height="30" width="128"></a>
      <!--<a class="navbar-brand"></a>-->
    </router-link>
    <button @click="expMenu" class="navbar-toggler navbar-toggler-right flex-sm-column" type="button" data-toggle="collapse" data-target="#collapse-menu" aria-expanded="false" aria-controls="collapse-menu">
                  <span class="navbar-toggler-icon"></span>
                </button>
    <!--</div>-->
    <!-- Collapse has to be right after button in v4 beta. -->
    <div class="collapse navbar-collapse" id="collapse-menu">
      <div v-bind:class="barObj" class="d-flex flex-md-row flex-sm-column justify-content-between hidden-lg-up">
        <ul class="navbar-nav nav" id="hdr-bar">

          <router-link tag="li" v-if="checkAuth" class="nav-item" active-class="active" exact :to="{ name: 'my-kh', params: { language: getLang }}">
            <a class="nav-link" data-toggle="collapse" data-target=".navbar-collapse">{{ nav[$route.params.language][11] }} </a> <!--My KH-->
          </router-link>

          <router-link tag="li" class="nav-item" active-class="active" exact :to="{ name: 'home', params: { language: getLang }}">
            <a class="nav-link" data-toggle="collapse" data-target=".navbar-collapse">{{ nav[$route.params.language][0] }} </a> <!--安裝-->
          </router-link>
          
          <router-link tag="li" class="nav-item" active-class="active" :to="{ name: 'product', params: { language: getLang }}">
            <a class="nav-link" data-toggle="collapse" data-target=".navbar-collapse">{{ nav[getLang][9] }}</a>
          </router-link>
          <!--<router-link tag="li" class="nav-item" active-class="active" :to="{ name: 'cart', params: { language: getLang }}">
            <a class="nav-link" data-toggle="collapse" data-target=".navbar-collapse">
              <span class="icon">
                <img alt="" class="logo" src="../assets/shopping_cart.png" style="width:24px;height:20px;">
              </span>
              <span class="badge" style="background-color: #98bafa; border-radius: 10px; color: white; display: inline-block; font-size: 12px; line-height: 1; padding: 3px 7px; text-align: center; vertical-align: middle; white-space: nowrap;">
                {{itemsInCart}}</span>
            </a>
          </router-link>-->
          <li class="nav-item dropdown" data-toggle="collapse" data-target=".navbar-collapse"> <!--語言選單-->
            <a class="nav-link dropdown-toggle" href="" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"> Language: {{ nav[getLang][5] }}</a>
            <aq-drop-lang></aq-drop-lang>
          </li>
         
          <router-link tag="li" v-if="checkAuth" class="nav-item" active-class="active" exact :to="{ name: 'profile', params: { language: getLang }}">
               <a class="nav-link" data-toggle="collapse" data-target=".navbar-collapse"> 
                 <img alt="" class="logo" src="../assets/user.png" style="width:24px;height:20px;"> {{ uname }}</a> <!--會員頭像名稱-->
          </router-link>
        
          <router-link tag="li" class="nav-item" v-if="! checkAuth" active-class="active" :to="{ name: 'auth', params: { language: $route.params.language }}">
            <a class="nav-link" data-toggle="collapse" data-target=".navbar-collapse">{{ nav[$route.params.language][6] }}</a> <!--會員登入/註冊-->
          </router-link>
        </ul>
      </div>
    </div>
  </nav>
  
  </template>

<script>
  import has from 'lodash/has';
  //import Log from 'loglevel';
  import DropDown from './DropDownLang.vue';
  import {mapLang} from "../routes.js";
  const Nav = {
    'en': ['Installation', 'Wifi Setup', 'KH Settings', 'KH Calibration', 'KH Graphs', 'en', 'Login', 'Profile', 'Logout', 'Products', 'Cart','My KH'],
    'tw': ['安裝', 'Wifi 設定', 'KH 設定', 'KH 校正', 'KH 圖表', '繁體', '會員登入/註冊', '會員資料', '登出', '產品', '購物車','我的KH'],
    'cn': ['安装', 'Wifi 设置', 'KH 设置', 'KH 校准', 'KH 曲线', '简体', '会员登录/注册', '用户资料', '退出', '商品', '购物车','我的KH'],
    'vi': ['Cài đặt', 'Thiết lập Wifi', 'Cài đặt KH', 'Hiệu chỉnh KH', 'Đồ thị KH', 'Tiếng Việt', 'Đăng nhập', 'Hồ sơ', 'Đăng xuất', 'Sản phẩm', ' Giỏ hàng','KH của tôi'],
    'ms': ['Installation', 'Wifi Setup', 'KH Settings', 'KH Calibration', 'KH Graphs', 'Melayu', 'Login', 'Profile', 'Logout', 'Products', 'Cart','My KH'],
  }

  export default {
    components: {
      "aq-drop-lang": DropDown
    },
    props: {
    },
    data: () => {
      return {
        uname:"",  // for HTML 
        nav: Nav,
        menuClicked: false
      }
    },
    computed: {
      barObj: function() {
        // if (this.menuClicked) {
        //     return {"bar-style": true, "bar-container": false};
        // } else {
        //     return {"bar-style": false, "bar-container": true};
        // }
      },
      checkAuth: function() {
        let user = JSON.parse(localStorage.getItem("user")) || {}; 
        this.uname = user.name || JSON.parse(localStorage.getItem("user.name"));
        let storeUser = this.$store.getters.user;
        if (storeUser.name === '' && user) {
            this.$store.dispatch('setUser', user);
        }
        //console.log("login: check: auth: ", this.$auth.loggedIn(), this.user.name);
        //console.log("login: check: name: ", (this.$auth.loggedIn() && user.name));
        if (this.$auth.loggedIn() && this.uname) {
          return true;
        } else {
          return false;
        }
      },
      getLang: function() {
        //console.log("lang: ", mapLang(), this.$route.params);
        if (has(this.$route, "params.language")) {
          return this.$route.params.language;
        } else {
          return mapLang();
        }
      },
      itemsInCart: function() {
        let cart = this.$store.getters.inCart;
        return cart.reduce((accum, item) => accum + item.quantity, 0);
      },
      isAuth: function() {
        //console.log("this: auth: ", this.$auth.loggedIn());
        return this.$auth.loggedIn();
      },
      user: function() {
        //console.log("header: user: ", this.$store.getters.user);
        return this.$store.getters.user;
      }
    },
    methods: {
      expMenu: function() {
        this.menuClicked = true;
      },
      loggingOut: function() {
        //console.log('logout: check: ', this.$auth.loggedIn());
        this.$store.dispatch("setUser", {name: '', token: ''});
        this.$auth.destroyToken();
        //console.log('logout: check: destroy', this.$auth.loggedIn());
      }
    },
    mounted() {
    let user = JSON.parse(localStorage.getItem("user")) || {}; 
    this.uname= user.name || JSON.parse(localStorage.getItem("user.name"));;
    }
  };
</script>

<style lang="css">
  /* // load bootstrap */
  /* @import "~bootstrap/scss/bootstrap.scss"; */
  /* $fa-font-path: "~font-awesome/fonts"; */
  /* @import "~font-awesome/scss/font-awesome.scss"; */

  /* @media (min-width: 992px) {
     h1 {font-size:2.5rem;}
     // 1rem = 16px
  } */


  ul li {
    padding-left: 0.3em;
    padding-right: 0.3em;
  }

  li a {
    display: block;
  }

  #collapse-menu {
    padding-right: 1em;
  }

  #header {
    width: 100%;
    box-sizing: content-box;
    height: 20px;
         
    background-color: #e3f2fd;
    opacity: 0.95;
    filter: (opacity=50);
  }
  .bar-style {
    max-height:inherit; 
  }
  .bar-container {
    /* width: 100%; */
    padding-right: 1em;
    max-height: 40px;
  }
  #bname {
    font-size: 2.0rem;
    margin-right: 2.1rem;
    width: 10%;
  }
  .logo {
    float: left;
    max-height: 25px;
    width: auto;
  }
  body {
    /* padding-top: 4em; */
    line-height: 1.5;
  }


   /* @media screen and (device-width: 375px) and (device-height: 667px) { */
     /* body .nav-item {font-size:2rem;} 1rem = 16px */
   /* } */
   
  @media screen and (device-width: 375px) {
    body .nav-item {font-size:2rem;} /*1rem = 16px*/
    body h2 {font-size:3rem;}
    #header .navbar-brand {font-size:3rem;}
  }
  @media screen and (device-width: 412px) {
    body .nav-item {font-size:2rem;} /*1rem = 16px*/
    body h2 {font-size:3rem;}
    #header .navbar-brand {font-size:3rem;}
  }


  @media (max-width:767px) {  
  /*  .navbar-default {   */
      /* min-height: 30px; */
    }
  /* } */

  /*.rt-bar {    */
    /* display: inline, */
    /* float: right */
  /* }  */

  /* #hdr-bar {   */
    /* flex-direction: row; */
  /* }  */
  
</style>


// WEBPACK FOOTER //
// Header.vue?b93a8b10